import { render, staticRenderFns } from "./rewardRule.vue?vue&type=template&id=2d906884&scoped=true&"
import script from "./rewardRule.vue?vue&type=script&lang=js&"
export * from "./rewardRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d906884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d906884')) {
      api.createRecord('2d906884', component.options)
    } else {
      api.reload('2d906884', component.options)
    }
    module.hot.accept("./rewardRule.vue?vue&type=template&id=2d906884&scoped=true&", function () {
      api.rerender('2d906884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/rewardController/component/rewardRule.vue"
export default component.exports